
import { UNIT } from '../../constants/theme';

interface AssistanceStyles {
    versionText: {
        textAlign: 'right';
        marginRight: number;
    };
    gutters: {
        paddingLeft: number;
        paddingRight: number;
    };
}

export const styles = (): AssistanceStyles => ({
    versionText: {
        textAlign: 'right',
        marginRight: UNIT * 0.25
    },
    gutters: {
        paddingLeft: 30,
        paddingRight: 30
    }
});